import React from 'react';
import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
} from 'react-hook-form';
import { RegisterFormInputs } from '..';
import { TextInput } from '../../../../Inputs';
import { errorStyle } from '../../../../../constants/styles';
import Button from '../../../../Button';
import SocialAuthView from '../../SocialAuth';

interface RegisterFormDetailsProps {
  loading: boolean;
  validateAndNext: (data: any) => void;
  formProps: {
    control: Control<RegisterFormInputs, any>;
    errors: FieldErrors<RegisterFormInputs>;
    getValues: UseFormGetValues<RegisterFormInputs>;
  };
}
export default function RegisterDetailsForm({
  loading,
  validateAndNext,
  formProps,
}: RegisterFormDetailsProps) {
  const { getValues, control, errors } = formProps;

  const onFinish = () => {
    validateAndNext(getValues());
  };

  return (
    <div className="w-full max-w-sm">
      <div className="text-gray-300 text-xs w-full text-center mb-10">
        Step <strong>1</strong> of <strong>2</strong>
      </div>
      <Controller
        name="name"
        control={control}
        defaultValue=""
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <TextInput
            id="name"
            value={value}
            onChange={onChange}
            invalid={!!errors.name}
            placeholder="Full name"
          />
        )}
      />

      {errors.name && errors.name.type === 'required' && (
        <span className={errorStyle}>Full name is required</span>
      )}

      {errors.name && errors.name.type === 'api' && (
        <span className={errorStyle}>{errors.name.message}</span>
      )}

      <div className="mt-6 rounded-md shadow-sm">
        <Controller
          name="email"
          control={control}
          defaultValue=""
          rules={{
            required: true,
            pattern:
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          }}
          render={({ field: { onChange, value } }) => (
            <TextInput
              id="email"
              type="email"
              value={value}
              placeholder="Email Address"
              onChange={onChange}
              invalid={!!errors.email}
            />
          )}
        />

        {errors.email && errors.email.type === 'required' && (
          <span className={errorStyle}>Email address is required</span>
        )}
        {errors.email && errors.email.type === 'pattern' && (
          <span className={errorStyle}>Please enter a valid email address</span>
        )}

        {errors.email && errors.email.type === 'api' && (
          <span className={errorStyle}>{errors.email.message}</span>
        )}
      </div>

      <div className="mt-12">
        <Button
          text="Next"
          type="button"
          buttonStyle="gradiented"
          loading={loading}
          disabled={loading}
          onClick={() => {
            onFinish();
          }}
        />
      </div>

      <SocialAuthView />
    </div>
  );
}
